import React, { memo, useContext, useState, useEffect } from "react"
import ResultsContext from "@/contexts/ResultsContext"

const Contest: React.FC<{
  title: string
  indexContest: number
  inputs: { name: string; points: number }[]
}> = ({ title, inputs, indexContest }) => {
  const [selectedOption, setSelectedOption] = useState<number>(-1)
  const { results, setResults }: any = useContext(ResultsContext)

  const handleRadioChange = (value: number) => {
    let newPoints = 0

    if (selectedOption === value) {
      setSelectedOption(-1)
    } else {
      setSelectedOption(value)
      newPoints = inputs[value].points
    }

    setResults((prev: any) => {
      const updated = [...prev.contests]
      updated[indexContest] = newPoints
      return {
        ...prev,
        contests: updated
      }
    })
  }

  return (
      <div className='text-center'>
        <hr />
        <h1 className='text-[2.6rem] my-5'>{title}</h1>
        <div className='text-2xl'>
          {inputs.map((input, index) => (
              <div className='mb-7 flex flex-row' key={index}>
                <input
                    type='checkbox'
                    id={`contestInput${indexContest}_${index}`}
                    className='relative text-2xl w-6 h-6 outline-none transition-all duration-300 appearance-none flex content-center justify-center border-[0.3rem] border-btn rounded-full checked:bg-white16 mx-4'
                    name={`contest${indexContest}`}
                    checked={selectedOption === index}
                    onChange={() => handleRadioChange(index)}
                />
                <label htmlFor={`contestInput${indexContest}_${index}`}>
                  {input.name}
                </label>
              </div>
          ))}
        </div>
      </div>
  )
}

export default memo(Contest)
